import { FormProvider, useForm, type FieldErrors } from 'react-hook-form'

import { Button } from '@components/shared/Button'
import { Input } from '@components/shared/Input'
import { RowBox } from '@components/shared/RowBox'
import { Select } from '@components/shared/Select'
import { FilterIcon } from '@assets/svgs/FilterIcon'
import { CloseIcon } from '@assets/svgs/CloseIcon'
import { useAccessProfile } from '@pages/AccessProfile/context'
import { getProfileType } from '@pages/AccessProfile/helpers/getProfileType'
import { initialFormValues } from './form/initialFormValues'

import type { AccessProfileFiltersProps } from './types'
import type { AccessProfileFiltersFormProps } from './form/types'

import * as S from './styles'

export const AccessProfileFilters = ({ onFilter }: AccessProfileFiltersProps) => {
  const { profilesData, isProfilesLoading } = useAccessProfile()

  const methods = useForm<AccessProfileFiltersFormProps>({
    defaultValues: initialFormValues
  })

  const onError = (errors: FieldErrors<AccessProfileFiltersFormProps>) => console.log({ errors })

  const onSubmit = (formData: AccessProfileFiltersFormProps) => onFilter(formData)

  return (
    <FormProvider {...methods}>
      <RowBox columns={5} marginTop={48} marginBottom={24}>
        <Input name="userId" label="ID" placeholder="ID" disabled={isProfilesLoading} />

        <Select
          name="profileDescription"
          label="Descrição do Perfil"
          options={
            profilesData?.availableFilters?.profileDescription.map((profile) => ({ label: profile, value: profile })) ||
            []
          }
          disabled={isProfilesLoading}
        />

        <Select
          name="profileType"
          label="Tipo de Perfil"
          options={
            profilesData?.availableFilters?.profileType.map((profile) => ({
              label: getProfileType(profile),
              value: profile
            })) || []
          }
          disabled={isProfilesLoading}
        />
        <Select
          name="status"
          label="Status"
          options={profilesData?.availableFilters?.status.map((status) => ({ label: status, value: status })) || []}
          disabled={isProfilesLoading}
        />

        <S.FilterButtons>
          <Button
            width="100%"
            colorType="outlineBlue"
            rightIcon={<FilterIcon />}
            onClick={() => methods.handleSubmit(onSubmit, onError)()}
            disabled={isProfilesLoading}
          >
            Filtrar
          </Button>

          <Button
            width="100%"
            colorType="outlineBlue"
            rightIcon={<CloseIcon />}
            onClick={() => {
              methods.reset()
              onFilter(initialFormValues)
            }}
            disabled={isProfilesLoading}
          >
            Limpar
          </Button>
        </S.FilterButtons>
      </RowBox>
    </FormProvider>
  )
}
